import { Injectable } from '@angular/core';
import { FilterService } from '../core/services';
import { ColorModel } from './color.model';

@Injectable()
export class ColorService {
    private readonly chartEntityColors: any[] = [
        { name: 'NotLive', color: 'rgba(169, 169, 169, 0.9)' },

        { name: "Age", color: "#FAEF5C" },
        { name: 'Gender', color: '#D81A5D' },
        { name: 'Age & Gender', color: '#63C3A1' },
        { name: 'No Data', color: '#38C4E8' },

        { name: 'Device - Android', color: '#C593C2' },
        { name: 'No Device - Android', color: '#9CC9D9' },
        { name: 'Device - iOS', color: 'rgba(160, 85, 156, 1)' },
        { name: 'No Device - iOS', color: 'rgba(114, 165, 179, 1)' },
        { name: 'Device - Other', color: 'rgba(160, 85, 200, 1)' },
        { name: 'No Device - Other', color: 'rgba(114, 170, 215, 1)' },

        { name: "Plays Completed", color: "#51B182" },
        { name: "Requests", color: "#05B3E7" },
        { name: "Plays Started", color: "#E84752" },
        { name: "", color: "" },
    ];

    private readonly colorNotFound = 'rgb(0, 0, 0)';
    private entityColors: Array<ColorModel> = [];

    constructor(private filterService: FilterService) {
        this.entityColors = this.filterService.getColors();
    }

    //this method is used only by the chart generators
    public getColorsByNames(names: string[]) {
        let colors = [];
        for (let name of names) {
            let item = this.entityColors.find(x => x.entityName === name);
            if (item)
                colors.push(item.entityColor);
            else {
                let chartItem = this.chartEntityColors.find(x => x.name === name);
                if (chartItem) colors.push(chartItem.color);
                else colors.push(this.colorNotFound);
            }
        }
        return colors;
    }

    //this method is used only in the mediation component
    public getColorByName(name: string): string {
        let item = this.entityColors.find(x => x.entityName === name);
        if (item)
            return item.entityColor;
        else {
            let chartItem = this.chartEntityColors.find(x => x.name === name);
            if (chartItem) return chartItem.color;
            else return this.colorNotFound;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/color-service.ts